import axios from "axios";

export const TOKEN_KEY = "sk_token";
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/connexion";
    }
    return Promise.reject(e);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d.message === "string") return d.message;
  return String(d);
}

export const apiIssues = (e) => e?.response?.data?.detail?.issues || [];

export const fmtQty = (n) => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 3 }).format(n ?? 0);
export const fmtDate = (iso) => new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });

export async function download(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function lookupCode(code) {
  return (await api.get("/lookup", { params: { code } })).data;
}

export const MOVE_TYPES = {
  entree: "Entrée",
  sortie: "Sortie",
  ajustement: "Ajustement d'inventaire",
  sortie_kit: "Sortie kit",
};
